<template>
  <div
    class="animate-pulse bg-black-20"
    :class="{
      'h-12': isButton,
      'h-8 md:w-64': isHeadline,
      'w-32': !fullWidth && isHeadline,
      'w-w-32 ': !fullWidth && isButton,
      'w-full': isFullWidth,
    }"
    :style="{ width }"
  />
</template>

<script setup lang="ts">
const WIDTH_SEQUENCE = [100, 70, 80, 50, 60, 90, 40, 60, 60]

const {
  type = 'button',
  fullWidth = false,
  index = -1,
} = defineProps<{
  type?: 'button' | 'headline' | 'custom'
  fullWidth?: boolean
  index?: number
}>()

const isButton = computed(() => type === 'button')
const isHeadline = computed(() => type === 'headline')
const isFullWidth = computed(() => fullWidth === true)
const width = computed(() =>
  index < 0 ? undefined : WIDTH_SEQUENCE[index % WIDTH_SEQUENCE.length] + '%',
)
</script>
